const roleType = {
    ROLE_TYPE_SUBMISSION : 0,

    ROLE_TYPE_SYSTEM_ADMIN : 1,

    ROLE_TYPE_CARRIER : 2,

    ROLE_TYPE_AGENT : 3,

    ROLE_TYPE_SERVICE : 4,

    ROLE_TYPE_AGENCY_ADMIN : 5,

    ROLE_TYPE_CARRIER_ADMIN : 6,

    ROLE_TYPE_CARRIER_MGA : 7,

    ROLE_TYPE_TASK_USER : 8

};

angular.module('gw-um-j2js')
    .constant('roleType', roleType);